module.exports = __webpack_public_path__ + "static/media/pasticceria_6.adbf8b17.jpg";